import { render, staticRenderFns } from "./user-signatures.vue?vue&type=template&id=bee8f25c&scoped=true&"
import script from "./user-signatures.vue?vue&type=script&lang=js&"
export * from "./user-signatures.vue?vue&type=script&lang=js&"
import style0 from "./user-signatures.vue?vue&type=style&index=0&id=bee8f25c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee8f25c",
  null
  
)

export default component.exports